import { Subject } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { ISnListQueryParameters } from '@lib/api';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';
import { SnGroupsAPI } from 'libs/api/services/src/lib/groups.service';

@Component({
  selector: 'fs-add-inherit-policy-dialog',
  templateUrl: './add-inherit-policy-dialog.component.html',
  styleUrls: ['./add-inherit-policy-dialog.component.scss'],
})
export class AddInheritPolicyDialogComponent implements OnInit, OnDestroy {
  public formFields: SnFormFieldConfig[] = [];
  public form = new UntypedFormGroup({});
  public model: { policies: any[] } = { policies: [] };

  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _dialogRef: MatDialogRef<AddInheritPolicyDialogComponent>,
    private readonly _groupsAPI: SnGroupsAPI,
  ) {}

  public ngOnInit(): void {
    this.formFields = [
      {
        key: 'policies',
        type: 'http-select',
        templateOptions: {
          skipLoadMissing: true,
          label: t('common.groups'),
          multiple: true,
          valueProp: 'policies',
          labelProp: 'displayName',
          tooltipProp: 'description',
          infinityScroll: true,
          fetchDataFn: (params: ISnListQueryParameters) =>
            this._groupsAPI.getGroupList({
              ...params,
              isSystemManaged: true,
            }),
        },
      },
    ];
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public save(): void {
    const policies = [];
    this.model.policies.forEach((policy) => {
      policies.push(...policy);
    });
    this._dialogRef.close(policies);
  }

  public close(): void {
    this._dialogRef.close();
  }
}
